var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-user-view"}},[_c('main-info',{on:{"changeView":(value) => _vm.currview(value)}}),_c('action-container',{on:{"changeView":(value) => _vm.currview(value)}}),_c('details-info',{on:{"changeView":(value) => _vm.currview(value)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }